 import React, { useEffect, useState } from 'react';
 import { useToken } from '../contex/TokenProvider';
 import axios from 'axios';
 import { AiOutlineLoading3Quarters } from "react-icons/ai";
 import '../Style/HomeSlider.css';  
 import BaseUrl from '../api/BaseUrl';

 function HomeSliderView() {

   const {token} = useToken();
   const [loading, setLoading] = useState(null);
   const [image, setImage] = useState([]);
   const [errorMessage, setErrorMessage] = useState();

   useEffect(() => { 
     setLoading(true);
     setErrorMessage('');
     BaseUrl.get('/HomeSlider/get-all-sliderimage')  
     .then(res => {
      setImage(res.data.data);
      console.log(res.data.data);
      setLoading(false);
    })  
     .catch(err => {
      console.log(err)
      setErrorMessage('Error fetching data');
      setLoading(false);
    });
  }, [token]); 

  const handleDelete = (imageId) => {
    const confirm = window.confirm('Are you sure you want to delete this image?');
    if(confirm) {
      console.log('Attempting to delete image with ID:', imageId);  
    console.log('Using token:', token); 
      BaseUrl.delete(`/HomeSlider/remove-sliderimage/${imageId}`, {
      headers: {
        'Authorization' : `Bearer ${token}`,
      }  
      })
      .then(res => {   
        if (res.status === 200 || res.status === 204) {   
          setImage(prevImages => prevImages.filter(image => image.id !== imageId));  
        } else {  
          setErrorMessage('Failed to delete image. Please try again.');  
        }  
      })  
      .catch(err => {  
        console.log(err);  
        setErrorMessage('Error deleting image.');  
      });  
    }
  }

   return (
     <div className='py-[100px] mx-[100px]'>
        {errorMessage && <p className="text-red-500 text-center py-20 text-[20px]">{errorMessage}</p>}  
       {loading ? <AiOutlineLoading3Quarters className='loading mt-[100px] text-[30px] mx-auto'/> : 
         <div className='flex flex-row flex-wrap gap-10'>
           {image.map((images, i) => {
            return(
              <div className='flex flex-col gap-2 items-center w-[500px]' key={images.id}>
                <div className='flex flex-row gap-2 bg-slate-200'>
                  <div><img className='w-[400px]' src={images.imageDesktop} /></div>
                  <div><img className='w-[162px]' src={images.imageMobile} /></div>
                </div>
                <button onClick={() => handleDelete(images.id)} className='px-6 py-2 bg-red-500 rounded-lg text-white text-[12px] font-bold'>Delete</button> 
              </div>
            )
           })}
         </div>
       }
     </div>
   )
 }

 export default HomeSliderView
